import React, { useState, useEffect } from 'react'

interface EngravingInputProps {
    value: string
    onChange: (value: string) => void
    maxLength?: number
    className?: string
    placeholder?: string
    autoFocus?: boolean
}

const EngravingInput: React.FC<EngravingInputProps> = ({
    value,
    onChange,
    maxLength = 14,
    className = '',
    placeholder = 'Enter your engraving text',
    autoFocus = false
}) => {
    const [isValid, setIsValid] = useState(true)
    const [errorMessage, setErrorMessage] = useState('')

    const validateInput = (input: string): boolean => {
        if (!input) return true
        return /^[A-Za-z0-9\s.,!?\-'/]+$/.test(input)
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value
        // Only allow valid characters
        const validInput = newValue.replace(/[^A-Za-z0-9\s.,!?\-'/]/g, '')

        const valid = validateInput(validInput)
        setIsValid(valid)

        if (!valid) {
            setErrorMessage('Only letters, numbers, spaces, and basic punctuation (.,!?-\'/)')
        } else {
            setErrorMessage('')
        }

        onChange(validInput)
    }

    return (
        <div className="flex flex-col gap-1 w-full">
            <input
                type="text"
                value={value}
                onChange={handleChange}
                maxLength={maxLength}
                placeholder={placeholder}
                autoFocus={autoFocus}
                className={`${className} ${!isValid ? 'border-red-500 focus:ring-red-500' : ''}`}
            />
            {!isValid && (
                <p className="text-red-500 text-xs mt-1">{errorMessage}</p>
            )}
            <div className="text-xs text-gray-500 flex justify-between mt-1">
                <span>Characters remaining: {maxLength - value.length}</span>
                {value.length > 0 && (
                    <span className={isValid ? 'text-green-500' : 'text-red-500'}>
                        {isValid ? '✓ Valid text' : '✗ Invalid characters'}
                    </span>
                )}
            </div>
        </div>
    )
}

export default EngravingInput 